export default __webpack_public_path__ + "static/media/landing_bg.20b04549.png";